// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const runtimeEnv = (window as any).__RUNTIME_ENV__ as {
  version: string;

  stage: string;

  fronteggBaseUrl: string;
  fronteggClientId: string;

  apiBaseUrl: string;

  docsSiteURL?: string;
};

export default runtimeEnv;
